const ITEMS = [
  "From the Field to the Future of Pharma Marketing",
  "Building Pharma Brands",
  "Creating Market Impact",
  "Shaping the Future",
];

export const Marquee = ({ dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`relative overflow-hidden border-y py-6 ${dark ? "border-white/10 bg-[#0A192F]" : "border-[#0A192F]/10 bg-white"}`}
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center">
              <span
                className={`font-display text-3xl font-black uppercase tracking-tight md:text-5xl ${
                  i % 2 === 0 ? (dark ? "text-white" : "text-[#0A192F]") : dark ? "text-outline-light" : "text-outline"
                }`}
              >
                {t}
              </span>
              <span className={`mx-8 h-2.5 w-2.5 rotate-45 ${dark ? "bg-[#00E5FF]" : "bg-[#00BFA5]"}`} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
